import Query from 'system/Query';
import TabFilter from 'filters/TabFilter';
import PaginationFilter from 'filters/PaginationFilter';
import Map from 'filters/MapFilter';
import ListFilter from 'filters/ListFilter';
import $ from 'jquery';

let instance = null;

export default class Main {

  constructor() {
    if (!instance) {
      instance = this;
    } else {
      return instance;
    }
  }

  init() {

    this.query = new Query();
    this.handleMobileSidebar();

		let filters = [];

    let $filters = $('[data-wjp-filter]');

    $filters.each(function(index, item) {
      let filter = $(this).data('wjp-filter');

      let filterClass = require(`./filters/${filter}`);
      item.filter = new filterClass.default($(this));
      filters.push(item.filter);
    });

    let $components = $('[data-wjp-component]');

    $components.each(function(item) {
      // let $item = $(item);
      let component = $(this).data('wjp-component');

      let componentClass = require(`./components/${component}`);

      filters.push(new componentClass.default($(this)));
    });

    window.WJP.query.setFilters(filters);
    

  }

  handleMobileSidebar() {
    $("body").on('click', '[data-attr=open-sidebar]', () => {
      $("body").addClass("body-lock");
      $(".wjp-jobs .site-sidebar").addClass('show-on-mobile');
    })
    
    $("body").on('click', '[data-attr=close-sidebar]', () => {
      $("body").removeClass("body-lock");
      $(".wjp-jobs .site-sidebar").removeClass('show-on-mobile');
    })
  }

};

$(function() {

  require('./messages.js');

  $.messages.subscribeAll((action) => {
    console.log(action.type, action);
    if (action.type.indexOf('ERROR') !== -1 && noReport.indexOf(action.data.id) === -1) {
      alert(action.data.msg);
    }
  });


  if ( $('.wjp-jobs').length ) {
    window.WJP = new Main();
    window.WJP.init();

    /**
     * Fix the sidebar on pages with a back button
     */
    window.WJP.fixSidebarPosition = function(animate) {
      // let tableContainer = $(".wjp-jobs-table-container").eq(0);
      // let siteSidebar = $(".site-sidebar");
      // if(tableContainer.length > 0 && siteSidebar.length > 0) {
      //   let animate = (animate) ? animate : 0;
      //   // $(".site-sidebar").css('marginTop', 0);
      //   let difference = tableContainer.position().top - siteSidebar.position().top;
      //   // $(".site-sidebar").css('marginTop', difference);
      //   $(".site-sidebar").animate({
      //           marginTop: difference
      //   }, animate);
      // }
    }

    // window.WJP.fixSidebarPosition(250);

    window.WJP.reloadingHTML = "<div class='wjp-reloading'><span class='icon-spinner8 icon-spin'></span></div>";

    if (navigator.userAgent.match(/Mobi/)) {
        $("body").addClass("is-mobile");
    }

    $("body").on("click", ".wjp-jobs-social-share a.wjp-social", function(ev) {
    	ev.preventDefault();
    	let width = $(this).data('width') ? $(this).data('width') : 600;
    	let height = $(this).data('height') ? $(this).data('width') : 300;
    	// console.log(width, height);
    	windowpop($(this).attr('href'), width, height);
    });

    function windowpop(url, width, height) {
        let leftPosition, topPosition;
        //Allow for borders.
        leftPosition = 100;
        //Allow for title and status bars.
        topPosition = 100;
        //Open the window.
        window.open(url, "Window2", "status=no,height=" + height + ",width=" + width + ",resizable=yes,left=" + leftPosition + ",top=" + topPosition + ",toolbar=no,menubar=no,scrollbars=no,location=no,directories=no");
    }

    /**
     * jobs-table shortcode
     * Makes click on the table row work
     */
    $("body").on('click', '.wjp-jobs-table-container .wjp-jobs-table > div', function(ev) {
      if ( $(ev.target).is('.wjp-overlay') ||
           $(ev.target).parents().has('.wjp-overlay').length ) {
          return;
      }

    	let $link = $(this).find('a.wjp-title-link');

    	if($link.length !== 0) {
    		window.location.href = $link.attr('href');
    	}
    });

    $("body").on('click', '[data-wjp-confirm]', function(ev) {
      var msg = $(this).data('wjp-confirm');
      if (!confirm(msg)) {
          ev.preventDefault();
      }
    });

    /**
     * Modal code
     */
    $("body").on("click", 'a[rel*=wjp-modal]', function(ev) {
    	ev.preventDefault();
    	let url = $(this).attr('href');
    	let id = "apply-for-job";

    	let $modal = $("#" + id);

    	if($modal.length <= 0) {
    		$("body").append("<div class='wjp-modal-backdrop' id='" + id + "'><div class='wjp-modal'><div class='wjp-modal-close'>x</div>" + WJP.reloadingHTML + "<div class='wjp-modal-contents'></div></div></div>");
    		$modal = $("#" + id);
    		let $close = $modal.find(".wjp-modal-close");
    		$close.on('touchstart click', function(ev) {
    			$modal.fadeOut();
    			$("html").removeClass("wjp-modal-open");
    		});

    		$(window).on('resize', function(ev) {
    			$modal.removeClass('force-top');
    			if($modal.find('.wjp-modal').position().top < 0) {
    				$modal.addClass('force-top');
    			}
    		});
    	}
    	$modal.removeClass('wjp-loaded');
    	let $contents = $modal.find('.wjp-modal-contents');
    	$contents.html("<iframe></iframe>");
    	$contents.find('iframe').load(function() {
    		$modal.addClass('wjp-loaded');
    	});
    	$contents.find('iframe').attr('src', url);
    	$("html").addClass("wjp-modal-open");
    	$modal.fadeIn();
    });

    /* Fix acf map */
    if( typeof wp !== "undefined" && typeof wp.hooks !== "undefined" ) {
      wp.hooks.addFilter("acf.google_map_args", function( map ) {
        map.scrollwheel = false;
        map.draggable = false;
        map.zoomControl = false;
        map.panControl = false;
        map.rotateControl = false;
        map.scaleControl = false;
        map.streetViewControl = false;

        return map;
      });
    }





  }

  /* The map/list view switch */



  /**/
  });



/** WEBPACK FOOTER **
 ** ../assets/js/frontend.js
 **/